import * as React from 'react'
import { Mutation, MutationFunction } from 'react-apollo'
import { Heart } from 'react-feather'

import { LEAD_BOOKMARK_MUTATION, LEADS_FOR_PARENT_QUERY } from 'main/gql/lead'
import { LeadBookmark, LeadBookmarkVariables } from 'main/gql/lead/__generated__/LeadBookmark'
import CTAButton from 'main/pages/School/CTA/Content/common/CTAButton'
import { Hidden, palette, Visible } from 'main/ui'
import { useTranslation } from 'react-i18next'
import segment from 'util/analytics/segment'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { AddToFavorites_user } from './gql/__generated__/AddToFavorites'

interface IProps {
  schoolId: number
  user: AddToFavorites_user | null
  onClick: () => void
  full: boolean
}

const PRE = `${i18nKeyPrefix}-CTA-FAVORITES-UNBOOKMARKED`

export default function Unbookmarked(props: IProps) {
  const { full, schoolId, user, onClick } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const label = full ? t(`${PRE}-LABEL`) : t(`${PRE}-LABEL-MOBILE`)

  return (
    <Mutation<LeadBookmark, LeadBookmarkVariables>
      mutation={LEAD_BOOKMARK_MUTATION}
      refetchQueries={[{ query: LEADS_FOR_PARENT_QUERY }]}
    >
      {mutate => (
        <>
          <Visible lg xl>
            <CTAButton
              full={full}
              icon={<Heart color={palette.skyBlue2} />}
              kind="outline"
              label={label}
              pendo="school-page-bookmark-button"
              onClick={() => handleOnClick(mutate)}
            />
          </Visible>
          <Hidden lg xl>
            <CTAButton
              full={full}
              icon={<Heart color={palette.skyBlue2} />}
              kind="outline"
              label=""
              pendo="school-page-bookmark-button"
              onClick={() => handleOnClick(mutate)}
            />
          </Hidden>
        </>
      )}
    </Mutation>
  )

  function handleOnClick(mutate: MutationFunction<LeadBookmark, LeadBookmarkVariables>) {
    if (user) {
      trackBookmarkEvent(schoolId)
      mutate({ variables: { schoolId } })
    } else {
      onClick()
    }
  }
}

function trackBookmarkEvent(schoolId: number) {
  segment.track('Program Added To Favorites', { school_id: schoolId })
}
